import * as actionTypes from '../actionTypes/promoterTypes';

const initialState = {
  info: {},
  iframesList: [],
  iframe: {},
  availableEvents: [],
  loading: true,
  eventsLoading: true,
  theme: {},
};

const promoter = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_PROMOTER_INFO_START:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.GET_PROMOTER_INFO_SUCCESS:
            return {
                ...state,
                info: action.payload,
                loading: false,
            };
        case actionTypes.GET_PROMOTER_INFO_FAIL:
            return {
                ...state,
                loading: false,
            };

        case actionTypes.GET_IFRAMES_START:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.GET_IFRAMES_SUCCESS:
            return {
                ...state,
                iframesList: action.payload,
                loading: false,
            };
        case actionTypes.GET_IFRAMES_FAIL:
            return {
                ...state,
                loading: false,
            };

        case actionTypes.GET_IFRAME_START:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.GET_IFRAME_SUCCESS:
            return {
                ...state,
                iframe: action.payload,
                loading: false,
            };
        case actionTypes.GET_IFRAME_FAIL:
            return {
                ...state,
                loading: false,
            };

        case actionTypes.UPDATE_IFRAME_START:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.UPDATE_IFRAME_SUCCESS:
            return {
                ...state,
                iframe: action.payload,
                loading: false,
            };
        case actionTypes.UPDATE_IFRAME_FAIL:
            return {
                ...state,
                loading: false,
            };

        case actionTypes.DELETE_IFRAME_START:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.DELETE_IFRAME_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.DELETE_IFRAME_FAIL:
            return {
                ...state,
                loading: false,
            };

        case actionTypes.GET_AVAILABLE_EVENTS_START:
            return {
                ...state,
                eventsLoading: true,
            };
        case actionTypes.GET_AVAILABLE_EVENTS_SUCCESS:
            return {
                ...state,
                availableEvents: action.payload,
                eventsLoading: false,
            };
        case actionTypes.GET_AVAILABLE_EVENTS_FAIL:
            return {
                ...state,
                eventsLoading: false,
            };

        case actionTypes.GET_THEME_START:
          return {
              ...state,
              loading: true,
          };
        case actionTypes.GET_THEME_SUCCESS:
            return {
                ...state,
                theme: action.payload,
                loading: false,
            };
        case actionTypes.GET_THEME_FAIL:
            return {
                ...state,
                loading: false,
            };

        case actionTypes.UPDATE_THEME_START:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.UPDATE_THEME_SUCCESS:
            return {
                ...state,
                theme: action.payload,
                loading: false,
            };
        case actionTypes.UPDATE_THEME_FAIL:
            return {
                ...state,
                loading: false,
            };

        default:
            return state
    }
};

export default promoter;
